import { Button, ModalBody, ModalContent, VStack } from '@chakra-ui/react'
import React, { useRef, useState } from 'react'
import type { PickerValue } from '../../context/calendar-event.context'
import { useCalendarEvent } from '../../context/calendar-event.context'
import type { Client } from '../../models'
import { ClientPicker } from '../client-picker'
import { EventModalFooter } from './event-modal-footer'
import { EventModalHeader } from './event-modal-header'

interface ClientPickerModalProps {
  onSubmit: (value: PickerValue) => void
  onCreateClient: (value: PickerValue) => void
}

export const ClientPickerModal: React.FC<ClientPickerModalProps> = ({
  onSubmit,
  onCreateClient
}) => {
  const { currentEvent } = useCalendarEvent()
  const buttonRef = useRef<HTMLButtonElement>(null)

  const [inputText, setInputText] = useState('')
  const [selectedClient, setSelectedClient] = useState<Client | null>(
    currentEvent?.patient || null
  )

  const handleClientSelect = (client: Client) => {
    setSelectedClient(client)
    handleSubmit(client)
  }

  const handleInputChange = (inputText: string) => {
    setSelectedClient(null)
    setInputText(inputText)
  }

  const handleAddEventClicked = () => {
    setSelectedClient(null)
    handleSubmit(selectedClient)
  }

  const handleAddClientClicked = () => {
    onCreateClient({ client: null, inputText })
  }

  const handleSubmit = (selectedClient: Client | null) => {
    let client: Client | null = null
    if (selectedClient) {
      client = {
        id: selectedClient.id,
        firstName: selectedClient.firstName,
        lastName: selectedClient.lastName,
        email: selectedClient.email,
        phoneNumber: selectedClient.phoneNumber
      }
    }
    onSubmit({ client, inputText })
  }

  return (
    <ModalContent>
      <EventModalHeader
        showCloseButton={false}
        fontSize="12px"
        fontWeight="700"
        textAlign="left"
      >
        Tell us your client or describe the event
      </EventModalHeader>
      <ModalBody p="16px 24px">
        <VStack alignItems="flex-start">
          <ClientPicker
            value={currentEvent?.patient || null}
            errors={null}
            onInputChange={handleInputChange}
            onSelect={handleClientSelect}
            addEventClicked={handleAddEventClicked}
            addClientClicked={handleAddClientClicked}
          />
        </VStack>
      </ModalBody>
      <EventModalFooter>
        <Button
          ref={buttonRef}
          type="submit"
          width="100%"
          borderRadius="8px"
          fontSize="16px"
          isDisabled={!selectedClient && !inputText}
          m={0}
          onClick={() => handleSubmit(selectedClient)}
        >
          Schedule
        </Button>
      </EventModalFooter>
    </ModalContent>
  )
}
